/** Matches API default when `layout_sidebar_blocks` is unset (null) in the DB. */
export const DEFAULT_LAYOUT_SIDEBAR_BLOCKS: readonly string[] = [
  'missing_rsvp',
  'notable_events',
  'recent_tasks'
]

/**
 * Sidebar blocks the system tray can render from user preferences (subset of desktop).
 * Excludes blocks that do not fit the compact tray UI (e.g. task lists).
 */
export const TRAY_SUPPORTED_SIDEBAR_BLOCKS: readonly string[] = ['missing_rsvp', 'notable_events']

export function effectiveLayoutSidebarBlocks(value: string[] | null | undefined): string[] {
  return value == null ? [...DEFAULT_LAYOUT_SIDEBAR_BLOCKS] : value
}

/** Preference-driven tray blocks: same order as desktop, minus unsupported ids. */
export function effectiveTraySidebarBlocks(value: string[] | null | undefined): string[] {
  const blocks = effectiveLayoutSidebarBlocks(value)
  const allowed = new Set(TRAY_SUPPORTED_SIDEBAR_BLOCKS)
  return blocks.filter((id) => allowed.has(id))
}
